<template>
    <div id="loading" class="text-white">
        <template v-if="!stalled">
            <i class="far fa-spinner fa-spin"></i>
            <p class="my-2">Loading...</p>
        </template>

        <!-- 응답이 지나치게 늦을 때.
             ⚠️ 오버레이를 그냥 없애버리면 담당자가 결제 버튼을 다시 눌러 **중복결제**가 난다.
                (이 저장소의 결제 화면 5곳이 이 오버레이를 쓴다)
             그래서 자동으로 닫지 않고, "이미 처리됐을 수 있다"는 경고와 함께
             닫기를 담당자가 직접 누르게 한다. -->
        <template v-else>
            <i class="far fa-exclamation-circle"></i>
            <p class="my-2 text-center px-4">
                응답이 지연되고 있습니다.<br />
                <span class="small">
                    이미 처리되었을 수 있습니다.<br />
                    <b>다시 시도하기 전에 반드시 처리 내역을 먼저 확인해주세요.</b>
                </span>
            </p>
            <button type="button" class="btn-stalled-close" @click="stalled = false">닫기</button>
        </template>
    </div>
</template>

<script>
// 전체화면 로딩이 영원히 안 꺼지는 사고를 막는 안전망 (2026-08-20).
// 이 저장소는 API 호출 70곳 중 .catch 가 12곳뿐이라, 통신이 끊기면 loading 이 true 로 남아
// 화면이 잠긴다. 담당자는 새로고침으로 빠져나오고 → 결제를 다시 눌러 중복결제가 난다.
// 호출부를 전부 고치는 것과 별개로 여기서 한 번 더 막는다.
const STALL_MS = 30000;

export default {
    data() {
        return {
            stalled: false,
            stallTimer: null,
        };
    },
    mounted() {
        // v-if 로 띄우므로 표시될 때마다 새 인스턴스가 생긴다 = 매번 타이머가 새로 시작된다
        this.stallTimer = setTimeout(() => {
            this.stalled = true;
        }, STALL_MS);
    },
    beforeDestroy() {
        if (this.stallTimer) {
            clearTimeout(this.stallTimer);
            this.stallTimer = null;
        }
    },
};
</script>

<style lang="scss" scoped>
#loading{
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: #22212171;
    position: fixed;
    z-index: 999;
    backdrop-filter: blur(1px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    i.fa-spinner{
        font-size: 2rem;
    }
    i.fa-exclamation-circle{
        font-size: 2rem;
    }
    .btn-stalled-close{
        margin-top: .25rem;
        padding: .4rem 1.6rem;
        border: 1px solid rgba(255,255,255,.7);
        border-radius: 999px;
        background: transparent;
        color: #fff;
        font-size: .9rem;
    }
}
</style>
